// extracted by mini-css-extract-plugin
export default {"paginationSwiper":"IntractiveLearning_paginationSwiper__Bk0VX"};